import React from 'react';
import { useSelectedMetrics } from '../../../studio-blocks/logic/useSelectedMetrics';
import { useOptionsPerformanceSummaryColumnDefs } from './useOptionsPerformanceSummaryGrid';
import { GridWrapper } from '../../../studio-blocks/common';
import ExportableGrid from '../../../studio-blocks/components/grid/ExportableGrid';
import { useRecoilValue } from 'recoil';
import { isReportState, viewDataGridSizeType } from 'venn-state';
import { useCommonGridProps } from '../../../studio-blocks/logic/columnUtils';
import { DATA_TYPE_EXCEL_STYLES, DataGridSizeType, useAnalysis } from '../../../studio-blocks';

type OptionsPerformanceSummaryContentProps = Readonly<{
  id: string;
}>;

export const OptionsPerformanceSummaryContent = ({ id }: OptionsPerformanceSummaryContentProps) => {
  const { analyses, requests } = useAnalysis(id);

  const isReport = useRecoilValue(isReportState);
  const isCompact = useRecoilValue(viewDataGridSizeType(id)) === DataGridSizeType.COMPACT;
  const commonGridProps = useCommonGridProps();
  const subject = requests?.[0]?.subject;

  const selectedMetrics = useSelectedMetrics();

  const response = analyses?.[0]?.[0]?.optionsPerformanceSummaryResponses?.[0];

  const columnDefs = useOptionsPerformanceSummaryColumnDefs({ subject, selectedMetrics });
  const rowData = response?.summaries ?? [];

  return (
    <GridWrapper isReport={isReport}>
      <ExportableGrid
        {...commonGridProps}
        selectedRefId={id}
        exportable={false}
        rowData={rowData}
        columnDefs={columnDefs}
        excelStyles={DATA_TYPE_EXCEL_STYLES}
        isCompact={isCompact}
      />
    </GridWrapper>
  );
};
